import React, { FC } from 'react'

import { IconChargeToBillProps } from './IconChargeToBill.types'
import * as Styled from './styles/IconChargeToBill.style'

import { nonThemeableRules } from '../../ruleSet'

const IconChargeToBill: FC<IconChargeToBillProps> = ({
  size = nonThemeableRules.defaultSize as number as IconChargeToBillProps['size'],
  isResponsive = false,
}: IconChargeToBillProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M34.435 20.063h-7.59m-3.793 0h-1.897m13.28 4.969h-7.59m7.59 5.031h-7.59'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M15.012 28.063V13c0-.199.08-.39.22-.53l7.148-7.157a.75.75 0 0 1 .53-.22H40V38.29a2.845 2.845 0 0 1-2.845 2.845h-16.68'
          stroke='#fff'
          strokeWidth='2'
        />
        <path d='M22.6 5.573v7.495h-7.565' stroke='#fff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M15.462 39.24v-7.59m-3.792 3.795h7.587' stroke='#EA1A1A' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M15.465 27.857h-.002a7.588 7.588 0 0 0-7.588 7.588v.002a7.587 7.587 0 0 0 7.588 7.588h.002a7.587 7.587 0 0 0 7.587-7.588v-.002a7.588 7.588 0 0 0-7.587-7.588Z'
          stroke='#EA1A1A'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconChargeToBill
